jQuery  (
        function()
            {
            /* Hook all elements with "data-xhr-progress-bar" property */
            $(document).on
                (
                'click',
                "[data-xhr-progress-bar]",
                function(e)
                    {                    
                    $.xhrProgressBar = $(this).data('xhr-progress-bar');
                    }
                );



            /* Create progress functions for all new ajax requests */
            $.ajaxSetup     (
                                {
                                headers             :   {
                                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                                        },

                                xhrProgressBar      : null,
                                
                                updateProgressBar   : function(e)
                                                        {                                                                    
                                                        if(this.xhrProgressBar)
                                                            {
                                                            var progressBar = $(this.xhrProgressBar);
                                                            
                                                            var progress = Math.round((e.loaded / e.total) * 100);                                                                    
                                                            progress = (progress < 100) ? progress : 100;
                                                                
                                                            if(progressBar)
                                                                {
                                                                progressBar.css('width', progress + '%');
                                                                progressBar.html(progress + '%');
                                                                }                                                            
                                                            }

                                                        return;
                                                        },

                                uploadProgress      : function(e)
                                                        {
                                                        return;
                                                        }, 
                                                        
                                progress            : function(e)
                                                        {
                                                        return;
                                                        },                                                                    
                                        
                                xhr                 : function()
                                                        {
                                                        var myAjaxSetup = this;
                                                        
                                                        var myXhr = new window.XMLHttpRequest();                                                                                                                           
                                            
                                                        this.xhrProgressBar = $.xhrProgressBar;
                                                        $.xhrProgressBar = null;

                                                        myXhr.upload.addEventListener   (
                                                                                        "progress",
                                                                                        function(e)
                                                                                            {
                                                                                            if(e.lengthComputable)
                                                                                                {                                                                                                            
                                                                                                myAjaxSetup.updateProgressBar(e);
                                                                                                myAjaxSetup.uploadProgress(e);                                                                                                                  
                                                                                                }
                                                                                            },
                                                                                        false
                                                                                        );

                                                        myXhr.addEventListener          (
                                                                                        "progress",
                                                                                        function(e)
                                                                                            {
                                                                                            if(e.lengthComputable)
                                                                                                {                                                                                                     
                                                                                                myAjaxSetup.updateProgressBar(e);
                                                                                                myAjaxSetup.progress(e); 
                                                                                                }
                                                                                            },
                                                                                        false
                                                                                        );

                                                        return myXhr;
                                                        },
                                }
                            );                                                                       
            }
        );